"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInvalidTab = exports.createSchema = void 0;
var tables_1 = require("../../tables/tables");
var Utils_1 = require("../../Utils");
var AutoModuleHelpers_1 = require("../AutoModuleHelpers");
var autoModuleViewHelpers_1 = require("./autoModuleViewHelpers");
function createSchema(tab, config, viewModel) {
    var _a, _b, _c, _d, _e, _f, _g;
    var schema = {};
    if (config) {
        var populateView_1 = (0, autoModuleViewHelpers_1.shouldPopulateView)(viewModel.viewModel.derivedFunctions, viewModel.viewModel.imports, viewModel.viewModel.getAssignedImport, config);
        schema = {
            description: (_c = (_b = (_a = viewModel.viewModel).getModuleDescription) === null || _b === void 0 ? void 0 : _b.call(_a)) !== null && _c !== void 0 ? _c : (0, AutoModuleHelpers_1.getModuleDefaultDescription)(),
            title: config.moduleName,
            type: "object",
            properties: {},
        };
        var schemaBuilder_1 = {
            properties: {},
        };
        (_e = (0, Utils_1.values)((_d = viewModel.viewModel.components) !== null && _d !== void 0 ? _d : {})) === null || _e === void 0 ? void 0 : _e.forEach(function (entry) {
            var _a, _b, _c, _d, _e;
            var component = entry.component;
            if ((!populateView_1 && component.category != "import") ||
                isInvalidTab(component.tabs, tab)) {
                return;
            }
            if (!schemaBuilder_1[component.group]) {
                schemaBuilder_1[component.group] = {
                    title: (_c = (_b = (_a = viewModel.viewModel.derivedFunctions) === null || _a === void 0 ? void 0 : _a.overrideGroupTitle) === null || _b === void 0 ? void 0 : _b.call(_a, component.group)) !== null && _c !== void 0 ? _c : config === null || config === void 0 ? void 0 : config.UIGroups[component.group],
                    description: (_e = (_d = viewModel.viewModel.derivedFunctions) === null || _d === void 0 ? void 0 : _d.overrideGroupDescription) === null || _e === void 0 ? void 0 : _e.call(_d, component.group),
                    type: "object",
                    properties: {},
                };
            }
            schemaBuilder_1[component.group].properties = __assign(__assign({}, schemaBuilder_1[component.group].properties), getComponentSchema(component, tab, viewModel));
        });
        //Sort groups based on order of UIGroups and remove groups with no components
        (_g = (0, Utils_1.getKeys)((_f = config.UIGroups) !== null && _f !== void 0 ? _f : {})) === null || _g === void 0 ? void 0 : _g.forEach(function (group) {
            var _a, _b, _c, _d;
            if (((_d = (_c = (0, Utils_1.getKeys)((_b = (_a = schemaBuilder_1[group]) === null || _a === void 0 ? void 0 : _a.properties) !== null && _b !== void 0 ? _b : {})) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : -1) > 0 &&
                schema.properties) {
                schema.properties[group] = schemaBuilder_1[group];
            }
        });
    }
    return schema;
}
exports.createSchema = createSchema;
function getComponentSchema(component, tab, viewModel) {
    var _a;
    var schema = {};
    if (isInvalidTab(component.tabs, tab) ||
        (viewModel.model && (0, autoModuleViewHelpers_1.isComponentInvisible)(component, viewModel.model))) {
        return schema;
    }
    schema = addComponentSchema(component, viewModel);
    if (schema == undefined) {
        return schema;
    }
    if (shouldAddValidator(component, viewModel.viewModel.derivedFunctions)) {
        schema = addComponentValidator(schema, component, viewModel.viewModel.derivedFunctions);
    }
    var componentName = component.name;
    schema = (_a = {}, _a[componentName] = __assign({}, schema), _a);
    return schema;
}
function isInvalidTab(tabs, tab) {
    return tabs.indexOf(tab) == -1;
}
exports.isInvalidTab = isInvalidTab;
function addComponentValidator(schema, component, derivedFunctions) {
    return __assign(__assign({}, schema), derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions[component.name + "Validator"]());
}
function shouldAddValidator(component, derivedFunctions) {
    return (component.validation &&
        derivedFunctions &&
        (derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions[component.name + "Validator"]) != null);
}
function addComponentSchema(component, viewModel) {
    if (component.category === "software") {
        return getSoftwareComponentSchema(component, viewModel.viewModel.derivedFunctions);
    }
    else if (component.category === "hardware") {
        return getHardwareComponentSchema(component, viewModel);
    }
    else if (component.category === "import") {
        return getDependencyComponentSchema(component, viewModel);
    }
    else if (component["category"] === "table") {
        return (0, tables_1.getTableComponentSchema)(component, viewModel);
    }
    return undefined;
}
function getSoftwareComponentSchema(component, derivedFunctions) {
    var _a, _b, _c, _d, _e, _f;
    var schema = {};
    if (component.type === "ComboBox") {
        schema = {
            type: "string",
            title: (_b = (_a = derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions.overrideTitle) === null || _a === void 0 ? void 0 : _a.call(derivedFunctions, component.name)) !== null && _b !== void 0 ? _b : component.description,
            default: (0, AutoModuleHelpers_1.getDefaultValue)(derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions.overrideDefaultValues, component),
            enum: (0, AutoModuleHelpers_1.getComboOptions)(derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions.overrideOptions, component),
        };
    }
    else if (component.type === "hex") {
        schema = {
            type: "integer",
            title: (_d = (_c = derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions.overrideTitle) === null || _c === void 0 ? void 0 : _c.call(derivedFunctions, component.name)) !== null && _d !== void 0 ? _d : component.description,
            format: "hex",
            default: (0, AutoModuleHelpers_1.getDefaultValue)(derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions.overrideDefaultValues, component),
        };
    }
    else if (component.type === "DescriptionOnly") {
        schema = {
            type: "null",
            title: component.description,
        };
    }
    else {
        schema = {
            type: component.type,
            title: (_f = (_e = derivedFunctions === null || derivedFunctions === void 0 ? void 0 : derivedFunctions.overrideTitle) === null || _e === void 0 ? void 0 : _e.call(derivedFunctions, component.name)) !== null && _f !== void 0 ? _f : component.description,
        };
        if ((0, autoModuleViewHelpers_1.isUrl)(component) && component.urlDescription) {
            schema = __assign(__assign({}, schema), { description: component.urlDescription });
        }
        if ((0, autoModuleViewHelpers_1.isImage)(component) && component.imageDescription) {
            schema = __assign(__assign({}, schema), { description: component.imageDescription });
        }
    }
    return schema;
}
function getDependencyComponentSchema(component, viewModel) {
    var _a, _b, _c, _d, _e;
    var schema = {};
    if (component.type === "ComboBox" && viewModel.model) {
        var dependencySelector = new AutoModuleHelpers_1.DependencySelector(viewModel.model, component);
        if (dependencySelector.getDropdownOptionNames().length <= 0) {
            return schema;
        }
        var dropdownOptions = dependencySelector.getDropdownOptionNames();
        var assignedImport = (_b = (_a = viewModel.createProcessedImports) === null || _a === void 0 ? void 0 : _a.call(viewModel, "views")) === null || _b === void 0 ? void 0 : _b[component.importId];
        var NONE_1 = "None";
        var assignedName = NONE_1;
        var selectedDependency = viewModel.model.getComponentValue(component.name);
        if (assignedImport === null || assignedImport === void 0 ? void 0 : assignedImport.handle) {
            assignedName = dependencySelector.createOptionLabel(assignedImport.handle, assignedImport.payload);
            dropdownOptions.push(assignedName);
        }
        else if (selectedDependency) {
            dropdownOptions.push(selectedDependency);
        }
        dropdownOptions = dropdownOptions.sort(function (a, b) {
            return a.localeCompare(b);
        });
        dropdownOptions = __spreadArray([NONE_1], dropdownOptions.filter(function (item) { return item !== NONE_1; }), true);
        schema = {
            type: "string",
            title: (_e = (_d = (_c = viewModel.getDerivedFunction).overrideTitle) === null || _d === void 0 ? void 0 : _d.call(_c, component.name)) !== null && _e !== void 0 ? _e : component.description,
            default: assignedName,
            enum: dropdownOptions,
        };
    }
    return schema;
}
function getHardwareComponentSchema(component, viewModel) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var schema = {};
    var model = viewModel.model;
    if (model) {
        if (model.getComponentValue(component.name) !== undefined &&
            component.type !== "register") {
            if (component.type === "ComboBox") {
                var setting = (0, AutoModuleHelpers_1.getSettingFromComponent)(model, component);
                schema = {
                    type: "string",
                    title: (_c = (_b = (_a = viewModel.getDerivedFunction).overrideTitle) === null || _b === void 0 ? void 0 : _b.call(_a, component.name)) !== null && _c !== void 0 ? _c : component.description,
                    default: (0, AutoModuleHelpers_1.getSettingDefaultIfPresent)(component, setting, (_e = (_d = model
                        .getDerivedFunctions()).overrideDefaultValues) === null || _e === void 0 ? void 0 : _e.call(_d, component.name)),
                    enum: (0, AutoModuleHelpers_1.getSettingOptionsIfPresent)(component, setting, model.getComponentValue((_g = (_f = component.mode) === null || _f === void 0 ? void 0 : _f.masterComponent) !== null && _g !== void 0 ? _g : "")),
                };
            }
            else {
                schema = {
                    type: component.type,
                    title: (_k = (_j = (_h = viewModel.getDerivedFunction).overrideTitle) === null || _j === void 0 ? void 0 : _j.call(_h, component.name)) !== null && _k !== void 0 ? _k : component.description,
                };
            }
        }
    }
    return schema;
}
//# sourceMappingURL=schema.js.map